import React from 'react';
import './About.css';
export default function About() {
  return (
    <section id='about' className='about-section'>
      <div className='section-heading'>
        <h1>About</h1>
      </div>
      <div className='about-me'>
        <p>
          Hi, I am Pankaj Asiwal from Bahadurgarh, Haryana. I have done my Graduation from{' '}
          <em> University Institute of Engineering and Technology </em>, Kurukshetra University, Kurukshetra. Now I am
          looking for my first Full-Time Job. I have Experience in Building Web Applications. I have Knowledge of some
          Tech Stack like Python, JavaScript, React.js, Node.js and Still Learning !!!
        </p>
      </div>
      <div className='education-container'>
        <div class='collage'>
          <h3>University Institute of Engineering And Technology [2019-2023]</h3>
          <p>Kurukhetra University</p>
          <p>
            <em>Electronics and Communication Engineering</em>
          </p>
        </div>
        <div class='cgpa'>
          <h3>7.7/10</h3>
          <p>CGPA</p>
        </div>
        <div class='school-1'>
          <h3>Vijaya Sr. Sec. School [2018-219]</h3>
          <p>Bahadurgarh</p>
          <p>
            <em>12th-Non-Medical</em>
          </p>
        </div>
        <div class='percentage-1'>
          <h3>72</h3>
          <p>Percentage</p>
        </div>
        <div class='school-2'>
          <h3>Vijaya Sr. Sec. School [2016-2017]</h3>
          <p>Bahadurgarh</p>
          <p>
            <em>10th-General</em>
          </p>
        </div>
        <div class='percentage-2'>
          <h3>62</h3>
          <p>Percentage</p>
        </div>
      </div>
    </section>
  );
}
